import { useEffect, useState } from 'react'
import { verifyOtp,  sendOtp } from '../../api/auth'
import { useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import '../../styles/register.css'

export default function VerifyOtp() {
  const [otp, setOtp] = useState('')
  const [timeLeft, setTimeLeft] = useState(60)
  const { state } = useLocation()
  const navigate = useNavigate()

useEffect(() => {
  if (!state?.emailId) {
    navigate('/register')
  }
}, [state?.emailId, navigate])

  // Countdown timer
  useEffect(() => {
    if (timeLeft === 0) return
    const timer = setInterval(() => {
      setTimeLeft(t => t - 1)
    }, 1000)
    return () => clearInterval(timer)
  }, [timeLeft])

  const submit = async () => {
    try {
      await verifyOtp({ emailId: state.emailId, otp })
      Swal.fire('Verified', 'You can login now', 'success')
      navigate('/login')
    } catch {
      Swal.fire('Invalid OTP', 'Please try again', 'error')
    }
  }

  const resend = async () => {
    try {
      await sendOtp({ emailId: state.emailId })
      Swal.fire('Sent', 'New OTP sent to your email', 'success')
      setTimeLeft(60)
    } catch {
      Swal.fire('Error', 'Could not resend OTP', 'error')
    }
  }

  return (
    <div className="register-container">
      <h2>Verify Email</h2>

      <p className="redirect-text otp-email">
        We sent a 6-digit code to <br />
        <strong>{state?.emailId}</strong>
      </p>

      <input
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter OTP"
      />

      <button onClick={submit}>Verify OTP</button>

      <p className="redirect-text">
        {timeLeft > 0 ? (
          <span className="timer">Resend OTP in {timeLeft}s</span>
        ) : (
          <span className="resend" onClick={resend}>
         Resend OTP
          </span>
        )}
      </p>
    </div>
  )
}
